import React, { useContext, useState, useCallback, useEffect, createContext, } from 'react';
import classnames from 'classnames';
import { useOnScroll } from '@wix/da-hooks/pkg/useOnScroll';
import { PopupContext } from '@wix/da-ds/pkg/popups/PopupContext';
import { scrollTo } from '../utils/browser';
import s from './ScrollableContent.scss';
var THROTTLE_TIMEOUT = 200;
export var ScrollableContentContext = createContext(undefined);
var ScrollableContent = function (_a) {
    var id = _a.id, role = _a.role, wrapperClassName = _a.wrapperClassName, styles = _a.styles, className = _a.className, children = _a.children, _b = _a.throttleTimeout, throttleTimeout = _b === void 0 ? THROTTLE_TIMEOUT : _b, onScrolled = _a.onScrolled, onNotScrollable = _a.onNotScrollable, _c = _a.scrolledToBottom, scrolledToBottom = _c === void 0 ? false : _c, innerRef = _a.innerRef, ariaHidden = _a["aria-hidden"];
    var contentRef = React.useRef(null);
    var setScrollableContentRef = useContext(PopupContext).setScrollableContentRef;
    var _d = useState(false), isScrolled = _d[0], setScrolled = _d[1];
    var handleScroll = useCallback(function (scrollTop, distanceToBottom) {
        onScrolled && onScrolled(scrollTop, distanceToBottom);
        var scrolled = scrollTop > 0;
        if (isScrolled !== scrolled) {
            setScrolled(scrolled);
        }
    }, [onScrolled, isScrolled]);
    useEffect(function () {
        var contentNode = contentRef.current;
        if (contentNode && scrolledToBottom) {
            scrollTo(contentNode, 0, contentNode.scrollHeight);
        }
    }, [scrolledToBottom]);
    useEffect(function () {
        var contentNode = contentRef.current;
        if (!contentNode) {
            return;
        }
        if (contentNode.clientHeight === contentNode.scrollHeight) {
            onNotScrollable && onNotScrollable();
        }
    }, [children, onNotScrollable]);
    useOnScroll(contentRef, handleScroll, throttleTimeout, true);
    var setRef = function (node) {
        contentRef.current = node;
        innerRef && innerRef(node);
        setScrollableContentRef(node);
    };
    return (React.createElement("div", { id: id, role: role, className: classnames(s['root'], wrapperClassName), "aria-hidden": ariaHidden },
        React.createElement(ScrollableContentContext.Provider, { value: contentRef },
            React.createElement("div", { style: styles, className: classnames(s['content'], className), ref: setRef }, children))));
};
ScrollableContent.displayName = 'ScrollableContent';
export default ScrollableContent;
//# sourceMappingURL=ScrollableContent.js.map